// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1exAb","title":"AfterBackImages_title__39jxi","images":"AfterBackImages_images__1HOFs"};